import React from 'react';
import PropTypes from 'prop-types';

import {
  ActivityAnalysisNormalSmall,
  ActivityBeaconNormalSmall,
  ActivityFinishNormalSmall,
  ActivityRoutesNormalSmall,
  ActivitySegmentNormalSmall,
  ActivityZonesNormalSmall,
  NavigationGroupNormalSmall,
  NavigationMapHeatSmall,
  NavigationTrainingNormalSmall
} from '@strava/icons';

import styles from './index.scss';

const FeaturesSection = ({ featuresSection: { headline, columns } }) => {
  const icons = {
    ActivityAnalysisNormalSmall: <ActivityAnalysisNormalSmall />,
    ActivityBeaconNormalSmall: <ActivityBeaconNormalSmall />,
    // This icon was included in desgins but not found when importing...
    ActivityFinishNormalSmall: <ActivityFinishNormalSmall />,
    ActivityRoutesNormalSmall: <ActivityRoutesNormalSmall />,
    ActivitySegmentNormalSmall: <ActivitySegmentNormalSmall />,
    ActivityZonesNormalSmall: <ActivityZonesNormalSmall />,
    NavigationGroupNormalSmall: <NavigationGroupNormalSmall />,
    NavigationMapHeatSmall: <NavigationMapHeatSmall />,
    NavigationTrainingNormalSmall: <NavigationTrainingNormalSmall />
  };

  const renderBlurb = (blurb, group) => {
    const hasIcon = blurb.icon && Object.keys(icons).indexOf(blurb.icon) >= 0;
    return (
      <div className={styles.blurb} key={`${group}-${blurb.header}`}>
        <div className={styles.blurbIconContainer}>
          {hasIcon && icons[blurb.icon]}
        </div>
        <div className={styles.blurbContent}>
          <p className={`${styles.body2} text-bold`}>{blurb.header}</p>
          <p className={styles.caption}>{blurb.text}</p>
        </div>
      </div>
    );
  };

  return (
    <div className={styles.featuresSection}>
      <div className={styles.row}>
        <div className="col-xs-12 col-sm-8 col-sm-offset-2 text-center">
          <p className={`${styles.subtitle1} ${styles.subhead}`}>{headline}</p>
        </div>
      </div>
      <div className={styles.row}>
        {columns.map((column) => (
          <div
            className={`col-xs-12 col-sm-4 ${styles.featureColumn}`}
            key={column.headline}
          >
            <img
              alt={column.headline}
              className={styles.columnImage}
              src={column.img_src}
            />
            <p className={`${styles.subtitle2} ${styles.columnHeadline}`}>
              {column.headline}
            </p>
            <p className={`${styles.body2} ${styles.columnText}`}>
              {column.text}
            </p>
            <div className={styles.mobile}>
              {column.blurbs.map((blurb) => renderBlurb(blurb, 'mobile'))}
            </div>
          </div>
        ))}
      </div>
      <div className={`${styles.row} ${styles.desktop}`}>
        {columns.map((column) => (
          <div className="col-xs-12 col-sm-4" key={`${column.headline}-blurbs`}>
            {column.blurbs.map((blurb) => renderBlurb(blurb, 'desktop'))}
          </div>
        ))}
      </div>
    </div>
  );
};

FeaturesSection.propTypes = {
  featuresSection: PropTypes.shape({
    headline: PropTypes.string.isRequired,
    columns: PropTypes.arrayOf(
      PropTypes.shape({
        img_src: PropTypes.string.isRequired
      })
    ).isRequired
  }).isRequired
};

export default FeaturesSection;
